'use strict';
const BuildContext = require('./BuildContext');
const getDistinctTranslationLocale = require('../rlink-regions/getDistinctTranslationLocale');

module.exports = class PrerenderBuildContext extends BuildContext {
  constructor ({appName, entryName, debug, useLongCaches, useLiveSafetyFeatures, defaultLocale, defaultRegion, locales, appIndexer, contentRoot, untranslatedContentChecksums, translatedContentChecksums, loadMessagesForLocale, appRoot}) {
    super();
    this.appName = appName;
    this.entryName = entryName;
    this.debug = !!debug;
    this.useLongCaches = !!useLongCaches;
    this.useLiveSafetyFeatures = !!useLiveSafetyFeatures;
    this.defaultLocale = defaultLocale;
    if (!defaultRegion) {
      throw new Error('defaultRegion is required!');
    }
    this.defaultRegion = defaultRegion;
    this.locales = locales;
    this.appIndexer = appIndexer;
    this.contentRoot = contentRoot;
    this.untranslatedContentChecksums = untranslatedContentChecksums;
    this.translatedContentChecksums = translatedContentChecksums;
    this.loadMessagesForLocale = loadMessagesForLocale;
    this.appRoot = appRoot;
  }

  get isPrerender () {
    return true;
  }

  get routeDefinitions () {
    return this.appIndexer.routeDefinitions;
  }

  get reduxStore () {
    return this.appIndexer.reduxStoreFor(this);
  }

  get regions () {
    return this.appIndexer.getAvailableRegions();
  }

  get contentRegistry () {
    return this.appIndexer.getContentRegistry();
  }



  loadViewFn (viewName) {
    let viewFn = this.appIndexer.getViewFunction(viewName);
    if (typeof viewFn !== 'function') {
      throw new Error(`Failed to load view function for: ${viewName} (got ${viewFn})`);
    }
    return viewFn;
  }

  contentForView (contentMetaIndex, view, params = {}) {
    let {locale = this.defaultLocale} = params;
    return this.appIndexer.repos(this.appRoot, getDistinctTranslationLocale(locale)).then(({workingRepo}) => this.appIndexer.appContentLoader(view, params, workingRepo));
  }

  ensureContentMetaIndexFor (existingIndex = {}, _view, _params) {
    let {untranslated, translated = {}} = existingIndex;
    if (untranslated === this.untranslatedContentChecksums && translated === this.translatedContentChecksums) {
      return Promise.resolve(existingIndex);
    } else {
      return Promise.resolve({
        untranslated: this.untranslatedContentChecksums,
        translated: this.translatedContentChecksums,
      });
    }
  }

  loadMessages (_view, {locale = this.defaultLocale} = {}) {
    return Promise.resolve(Object.assign({}, this.loadMessagesForLocale(getDistinctTranslationLocale(locale))));
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-router/PrerenderBuildContext.js